// Site version switch.
//
// The redesigned site is now the default for everyone. The old skyscraper
// dashboard is still deployed and reachable at ?legacy=1, so it can be checked
// against, or fallen back to, without editing code or redeploying. ?legacy=off
// returns to the current site.
//
// The choice persists in localStorage so client side navigation keeps working
// without carrying the query string on every link.

const STORAGE_KEY = 'portfolio-legacy';
const FLAG = '1';

/** True when the visitor should see the old skyscraper dashboard. */
export const showLegacySite = (): boolean => {
  let stored: string | null = null;
  try {
    stored = window.localStorage.getItem(STORAGE_KEY);
  } catch {
    // Private browsing or blocked storage. Fall through to query string only.
  }

  const param = new URLSearchParams(window.location.search).get('legacy');

  if (param === 'off') {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch {
      /* ignore */
    }
    return false;
  }

  if (param === FLAG) {
    try {
      window.localStorage.setItem(STORAGE_KEY, FLAG);
    } catch {
      // Storage unavailable, so this page works but navigation needs the
      // query string again.
    }
    return true;
  }

  return stored === FLAG;
};

/** Clears the legacy preference and returns to the current site. */
export const exitLegacy = () => {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
  window.location.href = '/';
};
